document.addEventListener('DOMContentLoaded', function() {
  const menuItem = document.querySelector('li.header__menu_li a[href*="shop-by-brand"]');
   const firstPathPart = window.location.pathname
  .split('/')
  .filter(Boolean)[0];

const localePrefix = /^[a-z]{2}(-[a-z]{2})?$/.test(firstPathPart)
  ? `/${firstPathPart}`
  : '';
  if (!menuItem) return;
 if (window.innerWidth >= 991) {
    menuItem.removeAttribute('href');
  }
  const popup = document.createElement('div');
  popup.className = 'brands-popup';

  const brands = {
    plastim:"https://cdn.shopify.com/s/files/1/0894/0139/3485/files/plastim-1.png?v=1760432064",
    opas:"https://cdn.shopify.com/s/files/1/0894/0139/3485/files/opas_206a17ac-8823-4448-9277-f445fbd95e71.png?v=1760542643",
    mucco:"https://cdn.shopify.com/s/files/1/0894/0139/3485/files/mucco.png?v=1760542208",
    bafra:"https://cdn.shopify.com/s/files/1/0894/0139/3485/files/bafra.png?v=1760435304",
    bylion:"https://cdn.shopify.com/s/files/1/0894/0139/3485/files/bylion_7c2005e2-9cae-426b-9da2-319e1c9159a5.png?v=1760542643",
    ars:"https://cdn.shopify.com/s/files/1/0894/0139/3485/files/ars.png?v=1760432065",
    noas:"https://cdn.shopify.com/s/files/1/0894/0139/3485/files/noas.png?v=1760453797",
    tense:'https://cdn.shopify.com/s/files/1/0894/0139/3485/files/tense.png?v=1760542049',
    onka:"https://cdn.shopify.com/s/files/1/0894/0139/3485/files/onka.png?v=1760542360",
  };

  popup.innerHTML = Object.entries(brands).map(([handle, imgUrl]) => `
    <a href="${localePrefix}/collections/${handle}" class="brand-item" title="${handle}">
      <img src="${imgUrl}" alt="${handle}">
    </a>
  `).join('');

  const li = menuItem.closest('li');
  li.style.position = 'relative';
  li.appendChild(popup);

  li.addEventListener('mouseenter', () => popup.classList.add('visible'));
  li.addEventListener('mouseleave', () => popup.classList.remove('visible'));

  menuItem.addEventListener('click', (e) => {
    e.preventDefault(); 
    e.stopPropagation();
    popup.classList.toggle('visible');
  });
  document.addEventListener('click', (e) => {
    if (!li.contains(e.target)) {
      popup.classList.remove('visible');
    }
  });
});